<main id="charging-stations" [class]="operator ? 'operator' : ''">
  <div class="card">
    <nav>
      <div class="nav-tab" id="nav-tab" role="tablist">
        <ul ngbNav #nav="ngbNav" [activeId]="activeTab" class="nav-tabs nav-pills">
          <li class="nav-item" [ngbNavItem]="'summary'" domId="tab_chargingstations">
            <a class="nav-link me-2 ps-2" ngbNavLink routerLink="summary" routerLinkActive="active">
              <app-svg source="icons/feather/charging-station" height="18"></app-svg>
              <span i18n="@@ChargingStationNavTab">Ladestationen</span>
            </a>
          </li>
          <li class="nav-item" [ngbNavItem]="'groups'" domId="tab_charingstations_groups"
            *ngIf="(permissions?.chargingstationsGroups && !this.user)">
            <a class="nav-link me-2 ps-2" ngbNavLink routerLink="groups" routerLinkActive="active">
              <app-svg source="icons/feather/charging-station-group" height="18"></app-svg>
              <span i18n="@@ChargingGroupsNavTab">Ladestationsgruppen</span>
            </a>
          </li>
        </ul>
      </div>
    </nav>

    <div class="card-body">
      <div class="tab-content mt-2" id="nav-tabContent">
        <router-outlet (activate)="onRouterOutletActivate($event)" (messageEvent)="receiveMessage($event)"></router-outlet>
      </div>
    </div>

    <div class="card-footer" [ngStyle]="{'display': componentSettings.footerVisible == true ? 'block' : 'none' }">
      <div class="d-flex">
        <div class="flex-fill d-none d-md-inline">
          <div class="d-flex">
            <div class="flex p-2" i18n="@@ElementsPerPage">Elemente pro Seite</div>
            <div class="flex">
              <select id="pageSize" name="pageSize" [(ngModel)]="tableFunctions.pageSize"
                class="form-control form-select custom-select" aria-label=""
                (change)="tableFunctions.onPageSizeChange(activeComponentClassName)">
                <option [ngValue]="10">10</option>
                <option [ngValue]="25">25</option>
                <option [ngValue]="50">50</option>
                <option [ngValue]="100">100</option>
                <option [ngValue]="250">250</option>
              </select>
            </div>
          </div>
        </div>
        <div class="d-flex d-md-inline-flex flex-fill text-center justify-content-center">
          <ngb-pagination #pagination [collectionSize]="(tableFunctions.total$ | async)!" [(page)]="tableFunctions.page"
            [pageSize]="tableFunctions.pageSize" [maxSize]="tableFunctions.page == 3 ? 3 : 2" [boundaryLinks]="true"
            [rotate]="true">
          </ngb-pagination>
        </div>
        <div class="flex-fill justify-content-end d-none d-md-inline">
          <div class="d-flex float-end">
            
            <div class="flex p-2" i18n="@@GoToPage">Springe zu Seite</div>
            <div class="flex">
              <select id="page" name="page" [(ngModel)]="tableFunctions.page" class="form-control form-select"
                aria-label="">
                <option *ngFor="let page of [].constructor(pagination.pageCount); let i = index" [ngValue]="i + 1">
                  {{ i + 1 }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
